import React from 'react';
import { useDispatch } from 'react-redux';
import * as XLSX from 'xlsx';
import { Driver } from 'services/action';

const BulkImport = ({ onImported, customer }) => {
  const Dispatch = useDispatch();
  const ref = React.useRef(null);

  const [loading, setLoading] = React.useState(false);

  const $handleImport = async (blob) => {
    setLoading(true);

    const promise = new Promise((resolve, reject) => {
      const reader = new FileReader();
      if (blob) {
        reader?.readAsArrayBuffer(blob);
        reader.onload = async function (e) {
          const buffer = e?.target?.result;
          const wb = XLSX?.read(buffer, { type: 'buffer' });
          const wsname = wb?.SheetNames[0];
          const ws = wb?.Sheets[wsname];
          const data = XLSX?.utils?.sheet_to_json(ws, { range: 1 });
          resolve(data);
        };

        reader.onerror = (error) => {
          reject(error);
        };
      }
    });

    promise.then(async (data) => {
      if (data) {
        let array = data;

        await array?.forEach(async (temp) => {
          const payload = {
            name: temp?.NAME,
            phone: temp?.PHONE_NUMBER?.toString(),
            vehicle_number: temp?.PLAT_NOMOR?.toString(),
            bank_account: temp?.BANK_ACCOUNT?.toString(),
          };

          await onImported(payload);
        });

        setTimeout(function () {
          setLoading(false);
        }, 10000);
      }
    });
  };

  return (
    <div className="text-center px-md-3 py-3">
      <div className="fs-6 fw-bold text-grey">Upload Data Driver</div>
      <div className="fs-8 text-grey">
        Anda dapat mengupload data driver dengan mengisi template XLS yang telah
        disediakan
      </div>
      {loading ? (
        <div className="text-center border border-primary p-3 rounded-2 mt-3 bg-primary-lt">
          <span
            className="spinner-border spinner-border me-2 text-primary mb-2"
            role="status"
          />
          <div className="fs-8 m-0 p-0 text-secondary fw-semibold">
            Mohon tunggu, proses import sedang berlangsung
          </div>
        </div>
      ) : (
        <div>
          <div className="d-block mt-3 mb-1">
            <div
              className="btn btn-sm btn-ghost-primary rounded-2 px-3"
              onClick={() => Dispatch(Driver.$download({"type": 'all'}))}
            >
              Download Template
            </div>
          </div>

          <div className="d-block">
            <div
              className="btn btn-sm btn-primary rounded-2 px-3"
              onClick={() => {
                ref?.current?.click();
              }}
            >
              Upload Data Driver
            </div>
            <input
              ref={ref}
              type="file"
              onChange={(e) => {
                $handleImport(e?.target?.files[0]);
              }}
              className="form-control d-none"
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BulkImport;
